var React = require('react');
var ReactIntl = require('react-intl');
var injectIntl = ReactIntl.injectIntl;
var defaultMessages = require('../../i18n/messages/default');
var { Button } = require('metro-ui-components');
var createReactClass = require('create-react-class');
var Utils = require('../../utils/Utils');
var YouAndMetroDigital = createReactClass({

    displayName: 'YouAndMetroDigital',

    render: function () {

        let count = Utils.getvalueCount(this.props.customerComponentLinks);

        let thirdButtonCss = '';
        let secondButtonCss = '';
        let firstButtonCss = '';
        let containerCss = 'row youAndMetroDigitalContainer';

        if (count == 1) {
            firstButtonCss = 'create-login-button';
            secondButtonCss = 'create-login-button';
            thirdButtonCss = 'create-login-button';
        }
        else if (count == 2) {
            firstButtonCss = 'create-login-button';
            secondButtonCss = 'become-customer-button';
            thirdButtonCss = 'become-customer-button';
        }
        else if (count == 3) {
            firstButtonCss = 'create-login-button';
            secondButtonCss = '';
            thirdButtonCss = 'third-button-of-you-and-metro';
            containerCss = 'row youAndMetroDigitalContainer3';
        }

        return (
            <div className={count > 2 ? "col-lg-5 col-md-5 col-sm-5 col-xs-12 " : "col-lg-5 col-md-5 col-sm-5 col-xs-12 topMargin"}>
                <div className="youAndMetroDigitalWrapper">
                    <div className={containerCss}>
                        <div className="centreAligned ">
                            {this.props.createLogin &&
                                <div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div className="font20bold">
                                            <span className="darkblue-text"> {this.props.intl.formatMessage(defaultMessages['alreadyAMetroCustomer'])} </span>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 btnwrapper">
                                        <a href={this.props.createLogin}>
                                            <Button id="createLogin" kind="secondary" size="large" type="button" className={firstButtonCss} value="createLogin" block={true}>
                                                {this.props.intl.formatMessage(defaultMessages['createLogin'])}
                                            </Button>
                                        </a>
                                    </div>
                                </div>
                            }
                            {this.props.newCustomerSignUpButton &&
                                <div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 youAndMetroDigitalInteralSeperator"></div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div className="font20bold second-button-of-you-and-metro">
                                            <span className="darkblue-text"> {this.props.intl.formatMessage(defaultMessages['areYouNewToMetroDigital'])}</span>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 btnwrapper">
                                        <a href={this.props.newCustomerSignUpButton}>
                                            <Button id="signup" kind="secondary" size="large" type="button" className={secondButtonCss} value="signup" block={true}>
                                                {this.props.intl.formatMessage(defaultMessages['newCustomerSignUpButton'])}
                                            </Button>
                                        </a>
                                    </div>
                                </div>
                            }
                            {this.props.signUpLink &&
                                <div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 youAndMetroDigitalInteralSeperator"></div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div className="font20bold second-button-of-you-and-metro">
                                            <span className="darkblue-text"> {this.props.intl.formatMessage(defaultMessages['signUpLinkLabel'])} </span>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 btnwrapper">
                                        <a href={this.props.signUpLink}>
                                            <Button id="signUpLink" kind="secondary" size="large" type="button" className={thirdButtonCss} value="signUpLink" block={true}>
                                                {this.props.intl.formatMessage(defaultMessages['signUpLink'])}
                                            </Button>
                                        </a>

                                    </div>
                                </div>
                            }

                        </div>
                    </div>
                </div>
            </div >
        );
    }
});

module.exports = injectIntl(YouAndMetroDigital);
